  // Keep the days value here equal to referrerDays in src/urls.js –
  // this whole file replaces that module’s urls export wholesale
  // rather than merging into it, so its own default query param
  // never reaches a deployed build otherwise
  export const urls = {
    app: "https://p3k.org/rss",
    proxy: "https://p3k.org/json/roxy",
    referrers: "https://p3k.org/json/ferris?group=rss-box&days=30"
  };
